import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class IncomeAndExpenditureParentModel extends ModelBase<IncomeAndExpenditureParentModel, IncomeAndExpenditureParentModelDTO> {
    // #region Defaults

    // #endregion Defaults

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults

    // #region Observables

    @observable
    public id: string = IncomeAndExpenditureParentModel.DEFAULT_ID;

    @observable
    public displayName: string = IncomeAndExpenditureParentModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = IncomeAndExpenditureParentModel.DEFAULT_ID;
        this.displayName = IncomeAndExpenditureParentModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: IncomeAndExpenditureParentModelDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: IncomeAndExpenditureParentModelDTO[]): IncomeAndExpenditureParentModel[] {
        const links: IncomeAndExpenditureParentModel[] = [];

        for (const dto of dtos) {
            const model = new IncomeAndExpenditureParentModel();

            model.fromDto(dto);
            links.push(model);
        }

        return links;
    }

    // #endregion Helpers
}

export interface IncomeAndExpenditureParentModelDTO {
    id: string;
    displayName: string;
}
